import { Connection } from '@solana/web3.js';
import { ChainId } from "../types";
var DEFAULT_CHAIN_ID = ChainId.MAINNET;
var DEFAULT_PROVIDER_URL = 'https://api.mainnet-beta.solana.com/';
var DEFAULT_API_URL = 'https://token-list-api.solana.cloud';
var DEFAULT_CDN_URL = 'https://cdn.jsdelivr.net/gh/solflare-wallet/token-list/solana-tokenlist.json';
var DEFAULT_TIMEOUT = 2000;
var DEFAULT_METAPLEX_TIMEOUT = 5000;
var UtlConfig = /** @class */ (function () {
    function UtlConfig(configOverrides) {
        if (configOverrides === void 0) { configOverrides = {}; }
        /**
         * Chain id - unique chain id (mainnet 101, testnet 102, devnet 103)
         */
        this.chainId = DEFAULT_CHAIN_ID;
        /**
         * Solana web3 connection
         */
        this.connection = new Connection(DEFAULT_PROVIDER_URL);
        /**
         * URL of unified token list backend
         */
        this.apiUrl = DEFAULT_API_URL;
        /**
         * URL where unified token list JSON is hosted
         */
        this.cdnUrl = DEFAULT_CDN_URL;
        /**
         * Number of miliseconds to wait for token list backend to respond
         */
        this.timeout = DEFAULT_TIMEOUT;
        /**
         * Number of miliseconds to wait for arweave to respond
         */
        this.metaplexTimeout = DEFAULT_METAPLEX_TIMEOUT;
        Object.assign(this, configOverrides);
    }
    return UtlConfig;
}());
export { UtlConfig };
